import { Document } from '@consigli/types';

import type {
  DocumentExcelPaneHighlight,
  DocumentViewerHighlight,
} from '@aecom-ai-engineering/react-components';

export function toExcelHighlight(
  coords: Document['findingCellCoordinates'],
): DocumentExcelPaneHighlight | undefined {
  if (!coords) return undefined;
  return { sheetName: coords.sheetName, row: coords.row, col: coords.col };
}

export function toHighlights(
  coordinates: Document['findingCoordinates'],
): DocumentViewerHighlight[] | undefined {
  if (!coordinates) return undefined;
  const { x0, y0, x1, y1, pageIndex } = coordinates;
  return [{ x0, y0, x1, y1, pageNumber: pageIndex + 1 }];
}
